import React, { useState } from 'react'
import { navigate } from 'gatsby'
import styled from 'styled-components'
import { AiOutlineSearch } from 'react-icons/ai'
import { device } from './Breakpoints'

const Container = styled.section`
  width: 100%;
  .mobile {
    position: absolute !important;
    z-index: 9999 !important;
    background: #ffff;
    width: 100%;

    @media ${device.tablet} {
      top: 89px;
    }
    @media ${device.mobileL} {
      top: 72px;
    }
    @media ${device.mobileS} {
      top: 65px;
    }

    .search form {
      margin: 0;
    }
  }
  .search {
    h1 {
      margin-bottom: 0;
      color: #8e8fc7;
      font-weight: normal;
      font-size: 1.8em !important;
      strong {
        color: #ff8f8c;
        font-family: 'Santral Bold', Arial, Helvetica, sans-serif;
      }
    }
    form {
      padding: 1em;
      background: #ff8f8c;
      margin-bottom: 2em;
      @media ${device.mobileL} {
        padding: 0.5em 1em;
        margin-bottom: 1em;
      }
      div {
        position: relative;
        box-sizing: border-box;
        svg {
          position: absolute;
          color: #ffffff;
          top: 6px;
          left: 10px;
          font-size: 1.7em;
          @media ${device.mobileL} {
            top: 2px;
            left: 6px;
          }
        }
      }
      input {
        border-radius: 50px;
        color: #ffffff;
        width: 100%;
        padding: 1em 1em 1em 3em;
        border: 1px solid #ffffff;
        background: transparent;
        box-sizing: border-box;
        ::placeholder {
          color: #ffffff;
        }
        @media ${device.mobileL} {
          padding: 0.7em 2.5em;
        }
      }
    }
  }
`
const AlignCenter = styled.div`
  max-width: 960px;
  margin: auto;
  @media ${device.mobileL} {
    max-width: 100%;
  }
`

const SearchMobileComponent = () => {
  const [queryObj, setQuery] = useState('')
  const handleSubmit = e => {
    e.preventDefault()
    const searchUrl = `/busca?s=${queryObj}`
    navigate(searchUrl)
  }
  const searchData = e => {
    setQuery(e.target.value)
  }

  return (
    <Container>
      <div className="mobile">
        <section className="search">
          <form onSubmit={handleSubmit}>
            <AlignCenter>
              <AiOutlineSearch />
              <input
                id="Search"
                value={queryObj}
                onChange={searchData}
                placeholder="Insira sua busca"
              />
            </AlignCenter>
          </form>
        </section>
      </div>
    </Container>
  )
}

export default SearchMobileComponent
